import * as React from "react";

interface IProps {
  children: any;
}

const H4 = (props: IProps) => (
  <h4 className="text-white font-bold font-montserrat">{props.children}</h4>
);

export default H4;



// WEBPACK FOOTER //
// ./src/components/general/headings/H4.tsx